import classNames from 'classnames';
import React from 'react';
import styles from './style.module.scss';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  styleType?: 'primary';
  block?: boolean;
}

const Button: React.FC<ButtonProps> = ({ type = 'button', className, styleType = 'primary', block, ...otherProps }) => {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={classNames(styles.button, styles[styleType], block && styles.block, className)}
      {...otherProps}
    />
  );
};

export default Button;
